import '../styles/ui.css';

export default function CardRow({ columns = [], actions = null, className = '' }) {
  return (
    <div className={`card-row ${className}`}>
      <div className="card-row__columns">
        {columns.map((col, idx) => (
          <div className="card-row__col" key={idx}>{col}</div>
        ))}
      </div>
      {actions && <div className="card-row__actions">{actions}</div>}
    </div>
  );
}
